import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0135c0b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "unit-radio-buttons" }
const _hoisted_2 = { class: "custom-unit-radio" }
const _hoisted_3 = ["value", "name", "checked"]
const _hoisted_4 = { class: "unit-radio-btn" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check" }, null, -1))
const _hoisted_6 = { class: "hobbies-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("input", {
        type: "radio",
        value: _ctx.value,
        name: _ctx.name,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
        checked: _ctx.value === _ctx.modelValue
      }, null, 40, _hoisted_3),
      _createElementVNode("span", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ])
    ])
  ]))
}